var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconConfirm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1453_43489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.24 0H17.76L0 17.76H148L130.24 0Z",
    fill: "#EA5504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1602 103.595H85.8402L109.494 68.0799V38.8789L62.1602 103.595Z",
    fill: "#EA5504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3379 59.2305V85.6512L62.1603 103.595H85.8404L50.3379 59.2305Z",
    fill: "#FFCFB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.24 0V148L148 130.24V17.76L130.24 0Z",
    fill: "#FFCFB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 130.238L17.76 147.998H130.24L148 130.238H0Z",
    fill: "#EA5504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.76V130.24L17.76 148V0L0 17.76Z",
    fill: "#FFCFB5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1453_43489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfirm);
export default __webpack_public_path__ + "static/media/icon_confirm.29bf24b8baeb902f15e4e4c791c7af5e.svg";
export { ForwardRef as ReactComponent };